import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo2 from '../img/logo2-branca.png';

const LINKS = [
  { hash: '#about', label: 'Sobre' },
  { hash: '#staff', label: 'Treinadores' },
  { hash: '#gallery', label: 'Galeria' },
  { hash: '#class', label: 'Horários' },
  { hash: '#location', label: 'Locais' },
  { hash: '#contact', label: 'Contacto' },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const solid = scrolled || pathname !== '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fecha o menu com Escape
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === 'Escape' && setIsOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen]);

  const close = () => setIsOpen(false);

  return (
    <header className={`header ${solid ? 'solid' : ''}`}>
      <Link to="/" className="logo-link" onClick={close} aria-label="HM Escola de Kickboxing — início">
        <img src={logo2} className="logo2" alt="" />
      </Link>

      <button
        className="toggle-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={isOpen}
        aria-controls="menu-principal"
      >
        <span aria-hidden="true">{isOpen ? '✕' : '☰'}</span>
      </button>

      <nav id="menu-principal" className={`nav ${isOpen ? 'open' : ''}`} aria-label="Principal">
        {LINKS.map(({ hash, label }) => (
          <Link key={hash} to={{ pathname: '/', hash }} onClick={close}>
            {label}
          </Link>
        ))}
      </nav>

      {isOpen && <div className="nav-backdrop" onClick={close} aria-hidden="true" />}
    </header>
  );
};

export default Header;
